import React, { memo } from 'react';
import SkeletonComponent from '../Skeleton/skeleton';

const TagSkeleton: React.FC = () => {

  const randomWidth = () => {
    return Math.floor(Math.random() * (90 - 60 + 1)) + 60
  };
  return (
    <div className="
          flex gap-2.5 items-center
          text-sm font-medium tracking-tighter
          undefined
          flex-wrap
        ">
      {
        Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className="">
            <SkeletonComponent className="rounded-[50px] mr-2" width={randomWidth()} height={30} />
          </div>
        ))
      }
    </div>
  );
};

export default memo(TagSkeleton);